<template>
  <div class="main col-xs-12">
    <AppMessages v-bind:message="this.message"
                 v-bind:show="this.show"
                 v-bind:type="this.messageType" />

    <div class="row">
      <h1 class="col-md-5">Print a CofA</h1>
    </div>
    <div class="row">
      <div class="col-md-5">
        <form class="noborder">

          <div class="form-group form-group--full">
            <label class="label">Customer</label>
            <selectize class="form-break" v-model="customer" :settings="customerSelectizeSettings" :disabled="isLoading">
              <option :value="customer.id" v-bind:key="customer.id" v-for="customer in customers" v-bind:data-sort-value="customer.name">{{ customer.name }}</option>
            </selectize>
          </div>

          <div class="form-group form-group--full"  v-show="customer">
            <div v-if="orderNos && orderNos.length">
              <label class="label">Order No</label>
              <selectize data-order v-model="order" :disabled="isLoading" :settings="selectizeSettings">
                <option :value="orderNo" v-bind:key="orderNo" v-for="orderNo in orderNos">{{ orderNo }}</option>
              </selectize>
            </div>
            <div v-else>
              <p v-show="!isLoading" style="color:red">Sorry, there are no orders for '{{ customer }}'. Please select another customer and try again. </p>
            </div>
          </div>

          <div class="form-group form-group--full" v-show="order">
            <div v-if="products && products.length">
              <label class="label">Product</label>
              <selectize data-product v-model="product" :settings="selectizeSettings">
                <option :value="product.code" v-bind:key="product.code" v-for="product in products">{{ product.code }}</option>
              </selectize>
              <span v-if="productCert" class="label label--alt-inline">Certificate Type: {{ productCert }}</span>
            </div>
            <div v-else>
              <p v-show="!isLoading" style="color:red">Sorry, unable to find order details for '{{ order }}' (data synchronisation error) . Please make sure the CofA and ERP databases are synchronised correctly.</p>
            </div>
          </div>

          <div class="form-group form-group--full" v-show="product">
            <label class="label">Batch No</label>
            <selectize data-batch v-model="batch" :settings="selectizeSettings">
              <option :value="batchNo" v-bind:key="index" v-for="(batchNo, index) in batchNos">{{ batchNo }}</option>
            </selectize>
          </div>


          <div v-show="batch">
            <div class="form-group form-group--full">
              <label class="label">Cert Type</label>
              <selectize v-model="certType" :disabled="true">
                <option value="A" selected="selected" >Analysis</option>
                <option value="C">Conformity</option>
              </selectize>
            </div>

            <div class="form-group form-group--full">
              <label class="label">Extra text</label>
              <input class="input form-block" v-model="extraText" />
            </div>

            <div class="form-group">
              <button class="button button--alt" type="button" :disabled="!isPrintEnabled" v-on:click="printPdf()">Print</button>
            </div>

            <div class="form-group form-group--full">
              <label class="label">Recipients</label>
              <p>
                Manually entered addresses must be separated with <b>";"</b>
              </p>
              <textarea v-model="companyemail" class="textarea form-block"
                  :class="{'form-group--error':invalidEmailMsg}"></textarea>
              <div class="error">{{ invalidEmailMsg }}</div>
            </div>

            <div class="form-group">
              <button class="button button--alt" type="button" v-on:click="sendPdf()" :disabled="!isSendEnabled">Send</button>
            </div>
          </div>
        </form>
      </div>

<div class="col-md-7" v-show="product">
  <h3 class="sub">Automatically Sent</h3>
  <p v-if="!showAutomaticEmails">None</p>
  <table v-if="showAutomaticEmails" class="table">
    <thead>
      <tr>
        <th class="table__header">Batch</th>
        <th class="table__header">Sent</th>
        <th class="table__header">On</th>
        <th class="table__header">To</th>
        <th class="table__header">Comment</th>
      </tr>
    </thead>
    <tbody>
      <tr v-bind:key="email.batch" v-for="email in automaticEmails">
        <td class="table__col">{{ email.batch }}</td>
        <td class="table__col u-capitalize">{{ email.sent }}</td>
        <td class="table__col">{{ email.date | formatDate }}</td>
        <td class="table__col">{{ email.sendTo }}</td>
        <td class="table__col">{{ email.extraText }}</td>
      </tr>
    </tbody>
  </table>

  <h3 class="sub">Manually Sent</h3>
  <p v-if="!showManualEmails">None</p>
  <table v-if="showManualEmails" class="table">
    <thead>
      <tr>
        <th class="table__header">UniKey</th>
        <th class="table__header">Company</th>
        <th class="table__header">Product</th>
        <th class="table__header">OrderNo</th>
        <th class="table__header">BatchNo</th>
        <th class="table__header">CertType</th>
        <th class="table__header">SentDate</th>
        <th class="table__header">SentTo</th>
        <th class="table__header">ExtraText</th>
      </tr>
    </thead>
    <tbody>
      <tr v-bind:key="email.uniKey" v-for="email in manualEmails">
        <td class="table__col">{{ email.uniKey }}</td>
        <td class="table__col u-capitalize">{{ email.company }}</td>
        <td class="table__col">{{ email.product }}</td>
        <td class="table__col">{{ email.orderNo }}</td>
        <td class="table__col">{{ email.batch }}</td>
        <td class="table__col">{{ productCert }}</td>
        <td class="table__col">{{ email.date | formatDate }}</td>
        <td class="table__col">{{ email.sendTo }}</td>
        <td class="table__col">{{ email.extraText }}</td>
      </tr>
    </tbody>
  </table>
</div>
    </div>
  </div>
</template>

<script>
  import Selectize from 'vue2-selectize';
  import axios from 'axios';
  import AppMessages from '@/components/AppMessages/AppMessages.vue';
  import SelectPopulate from '../mixins/SelectPopulate';

  export default {
    name: 'batchentry',
    components: {
      Selectize,
      AppMessages,
    },
    mixins: [SelectPopulate],
    data() {
      return {
        selectizeSettings: {
            maxOptions: 10000,
            sortField: [{ field: 'value', direction: 'asc' }, { field: '$score' }],
            allowEmptyOption: false,
            placeholder: 'Select value'
        },
        customerSelectizeSettings: {
            maxOptions: 10000,
            sortField: [{ field: 'data-sort-value', direction: 'asc' }, { field: '$score' }],
            allowEmptyOption: false,
            placeholder: 'Select value'
        },
        companyemail: null,
        customer: null,
        orderNos: [],
        order: null,
        products: [],
        product: null,
        batchNos: [],
        batch: null,
        certType: null,
        productCert: null,
        manualEmails: [],
        automaticEmails: [],
        extraText: null,
        message: '',
        messageType: '',
        show: false,
        isPrintEnabled: true,
        isSendEnabled: true,
        isLoading: false,
        invalidEmailMsg: null
      };
    },
    computed: {
      customers() {
        return this.$store.state.customers;
      },
      showAutomaticEmails() {
        return this.product && this.automaticEmails.length > 0;
      },
      showManualEmails() {
        return this.product && this.manualEmails.length > 0;
      },
    },
    watch: {
      customer(value) {

        this.reset(!value, true, true, true);

        if (!value) {
          return;
        }

        this.companyemail = null;
        this.invalidEmailMsg = null;

        const customer = this.customers.filter(x => x.id == value)[0];
        if (customer) {
          this.companyemail = customer.cofaEmail.join(';');
        }

        const $scope = this;
        const msg = 'Unable to retrive customer orders';

        this.isLoading = true;

        this.sendRequest(`/customers/${value}/orders`)
          .then((r) => {

            if (!r.success || (r.data && r.data.length == 0)) {
              $scope.orderNos = [];
              this.displayMsg(msg, 'error');
              this.$Progress.fail();
              return;
            }

            $scope.orderNos = r.data;
          })
          .catch(r => {
            this.message = msg;
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      order(value) {

        this.reset(false, !value, true, true);

        if (!value) {
          return;
        }

        const $scope = this;
        this.isLoading = true;
        this.loadOrderDetails(value, false).finally(() => {
          this.isLoading = false;
        });
      },
      product(value) {

        this.reset(false, false, !value, true);

        if (!value) {
          return;
        }

        this.productCert = null;

        this.loadProduct(value, true);
      },
    },
    methods: {
      loadOrderDetails(order, hideProgressOnCompletion) {
        var $scope = this;

        const encoder = new TextEncoder();
        const byteArray = encoder.encode(order);
        const base64Order = btoa(String.fromCharCode.apply(null, byteArray));

        return this.sendRequest(`/customers/${this.customer}/orders/${base64Order}`, hideProgressOnCompletion)
          .then((r) => {
            if (!r.success) {
              this.displayMsg(`Unable to find order detais for ${order}`, 'error');
              this.$Progress.fail();
              $scope.products = [];
              return;
            }

            $scope.products = r.data.products;
          });
      },
      loadProduct(product) {

        const prod = this.getProduct(product);
        if (prod) {
          this.productCert = prod.certificateType;
          this.batchNos = prod.batches.map(x => x.batchNo);

          let tempManualEmails = [];
          let tempAutomaticEmails = [];

          for (let i = 0; i < prod.batches.length; i++) {
            const b = prod.batches[i];
            tempManualEmails = tempManualEmails.concat(b.manualEmails);
            tempAutomaticEmails = tempAutomaticEmails.concat(b.automaticEmails);
          }

          this.manualEmails = tempManualEmails;
          this.automaticEmails = tempAutomaticEmails;

          this.certType = prod.certificateType || 'A';
        }
      },
      sendRequest(url, data, config, errorMessage, hideProgressOnCompletion) {
        this.$Progress.start();
        this.show = false;

        hideProgressOnCompletion = hideProgressOnCompletion || false;

        return axios.post(url, data, config)
          .then((r) => {

            if (!hideProgressOnCompletion) {
              this.$Progress.finish();
            }

            return {
              success: true,
              data: r.data,
            };
          })
          .catch((e) => {

            this.message = errorMessage;
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();

            return {
              success: false,
              data: e.response.data,
            };
          });
      },
      getJsonFromBlob(blob) {
        return blob.text().then(text => JSON.parse(text));
      },
      printPdf() {
        const data = {
          orderNumber: this.order,
          productCode: this.product,
          batchNumber: this.batch,
          certType: this.certType,
          extraText: this.extraText,
        };

        const config = {
          responseType: 'blob',
        };

        this.isPrintEnabled = false;

        return this.sendRequest(`/customers/${this.customer}/generate-cofa-pdf`, data, config, '')
          .then((response) => {
            if (!response.success) {

              this.getJsonFromBlob(response.data).then((text) => {

                // eslint-disable-next-line prefer-template
                this.message = 'Pdf could not be created. ' + text[0];
                this.messageType = 'message message--error';
                this.show = true;
                this.$Progress.fail();
              });

              return;

            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'cofa.pdf');
            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
              document.body.removeChild(link);
            }, 1000);

            this.message = 'Certificate has been generated';
            this.messageType = 'message message--success';
            this.show = true;
          })
          .finally(() => {
            this.isPrintEnabled = true;
          });
      },
      sendPdf() {
        const tryParseEmails = emails => {
          if (emails) {
            var parts = emails.trim().split(';');
            emails = [];
            for (var i = 0; i < parts.length; i++) {
              var e = parts[i].trim();
              if (e) {
                /* eslint-disable-next-line */
                if (!/^[^@ ]+@[^\. ]+\.[^ @]+$/g.test(e)) {
                  return [];
                }
                emails.push(e);
              }
            }
            return emails;
          }
          return [];
        };

        this.invalidEmailMsg = null;
        var emails = tryParseEmails(this.companyemail);

        if (!emails.length) {
          this.invalidEmailMsg = 'Invalid email(s) detected. For multiple recipients, you must separate using ";"';
          this.displayMsg(this.invalidEmailMsg, 'error');
          this.$Progress.fail();
          this.show = true;
          return null;
        }
        const data = {
          orderNumber: this.order,
          productCode: this.product,
          batchNumber: this.batch,
          certType: this.certType,
          extraText: this.extraText,
          Recipients: emails
        };
        this.show = false;
        this.isSendEnabled = false;
        this.companyemail = emails.join(';');

        return this.sendRequest(`/customers/${this.customer}/send-cofa-pdf`, data, null, 'Email could not be sent')
          .then((r) => {
            if (!r.success) {
              return;
            }

            this.isLoading = true;
            // refresh the screen
            this.loadOrderDetails(this.order, true)
              .then((r) => {
                this.loadProduct(this.product, true);
                this.$Progress.finish();

                this.message = 'Email has been sent';
                this.messageType = 'message message--success';
                this.show = true;
              })
          })
          .finally(() => {
            this.isSendEnabled = true;
            this.isLoading = false;
          });
      },
      getProduct(code) {
        return this.products.filter(x => x.code === code)[0];
      },
      getUniqueKey(prefix, index) {
        return `${prefix}_${index}`;
      },
      reset(customer, order, product, batch) {
        if (customer) {
          this.companyemail = null;
          this.customer = null;
          this.orderNos = [];
          this.invalidEmailMsg = null;
        }

        if (order) {
          this.products = [];
          this.order = null;
          this.manualEmails = [];
          this.automaticEmails = [];
        }

        if (product) {
          this.batchNos = [];
          this.product = null;
          this.productCert = null;
        }

        if (batch) {
          this.batch = null;
          this.certType = true;
          this.extraText = null;
        }
      },
      displayMsg(msg, type) {
          this.message = msg;
          this.messageType = `message message--${type}`;
          this.show = true;
      }
    },
  };
</script>
